import { z } from 'zod';
var InitialProps = z.object({
  permissions: z.record(z.string(), z.unknown())
  // Please avoid adding attributes here.  We're trying to move away from
  // initial props and adding attributes here makes it harder to migrate away
}).passthrough();
export var InitialPropsResponse = z.object({
  type: z.literal('application_page_initial_props'),
  attributes: InitialProps
});